import { Dispatch, SetStateAction, useContext } from "react";
import { acceptRejectUpdatedPrice } from "../../../../../api/quotation.api";
import { DecreaseGraphIconSvgPPP, IncreaseGraphIconSvgPPP } from "../../svgImages";
import "./style.scss";
import { IPriceData } from "../../..";
import SnackbarContext from "../../../../../context/snackbar.context";
interface IPriceUpdateModal {
  oldPrice: number;
  newPrice: number;
  priceIncreased: boolean;
  quotationId: string;
  setPrice: Dispatch<SetStateAction<IPriceData>>;
  updatedPrice: IPriceData;
  setData: any;
  handleClose: (value: React.SetStateAction<boolean>) => void;
}

const PriceUpdateModal: React.FC<IPriceUpdateModal> = (props) => {
  const snackbarCtx = useContext(SnackbarContext);
  const { oldPrice, newPrice, priceIncreased, quotationId, setPrice, updatedPrice, setData, handleClose } = props;

  const handleRevisedFare = async (status: string) => {
    try {
      const response = await acceptRejectUpdatedPrice(quotationId, status);
      if (response.status === 200) {
        if (status === "accept") {
          setPrice(updatedPrice);
          snackbarCtx.toggleSnackbar({
            message: "Fare updated successfully!!",
            type: "SUCCESS",
            visible: true,
          });
        } else if (status === "reject") {
          setData((prevData: any) => ({
            ...prevData,
            quotationDetails: { ...prevData.quotationDetails, status: "REJECTED" },
          }));
          snackbarCtx.toggleSnackbar({
            message: "Quotation Rejected!!",
            type: "FAILURE",
            visible: true,
          });
        }
        handleClose(false);
      }
    } catch (error) {
      snackbarCtx.toggleSnackbar({
        message: "Something went wrong!!",
        type: "FAILURE",
        visible: true,
      });
    }
  };
  

  return (
    <div className="price-update-modal-body-wrapper">
      <h3>
        {priceIncreased ? "Oops!" : "Wohoo!"} Fare {priceIncreased ? "Increased" : "Decreased"}
      </h3>
      <div className="graph-icon-wrapper">
        {priceIncreased ? <IncreaseGraphIconSvgPPP /> : <DecreaseGraphIconSvgPPP />}
      </div>
      <div className="fares-wrapper">
        <div className="fare-info-wrapper">
          <span>Previous Fare:</span>
          <span>{`₹ ${new Intl.NumberFormat("en-IN").format(oldPrice)}`}</span>
        </div>
        <div className="fare-info-wrapper">
          <span>Revised Fare:</span>
          <span>{`₹ ${new Intl.NumberFormat("en-IN").format(newPrice)}`}</span>
        </div>
      </div>
      <div className="button-wrapper">
        <button onClick={() => handleRevisedFare("reject")}>Reject Quotation</button>
        <button onClick={() => handleRevisedFare("accept")}>Accept Quotation</button>
      </div>
    </div>
  );
};

export default PriceUpdateModal;
